<template>
    <va-create-layout>
        <supplier-types-form :title="title" :item="item"></supplier-types-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"]
};
</script>
